import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { updateRequirementStatus } from '../services/api';

const STATUTS = ['Brouillon', 'En revue', 'Approuvee', 'Obsolete'];
const LABELS = {
  'Brouillon': 'Brouillon',
  'En revue': 'En revue',
  'Approuvee': 'Approuvee',
  'Obsolete': 'Obsolete',
};

export default function RequirementStatusBadge({ projectId, requirementId, statut, onUpdate, isAdmin }) {
  const [show, setShow] = useState(false);
  const [updating, setUpdating] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setShow(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = async (newStatut) => {
    if (updating || newStatut === statut) return;
    setUpdating(true);
    try {
      await updateRequirementStatus(projectId, requirementId, newStatut);
      setShow(false);
      if (onUpdate) onUpdate();
    } catch { /* handled by interceptor */ }
    setUpdating(false);
  };

  // CSS class: replace spaces with hyphens for class name
  const cssClass = `req-status-${statut.replaceAll(' ', '-')}`;

  // Filter available statuts: "Approuvee" only visible to admins
  const availableStatuts = STATUTS.filter((s) => s !== 'Approuvee' || isAdmin);

  return (
    <div className="position-relative d-inline-block" ref={ref}>
      <button
        type="button"
        className={`req-status-badge ${cssClass}`}
        onClick={(e) => { e.stopPropagation(); setShow(!show); }}
        onKeyDown={(e) => e.stopPropagation()}
        title="Cliquer pour changer le statut de validation"
        style={{ background: 'none', border: 'none', font: 'inherit', color: 'inherit', padding: 0, cursor: 'pointer' }}
      >
        {statut}
      </button>
      {show && (
        <div className="status-dropdown">
          {availableStatuts.map((s) => (
            <button
              type="button"
              key={s}
              className={`status-dropdown-item ${s === statut ? 'fw-bold' : ''}`}
              onClick={() => handleChange(s)}
              style={{ background: 'none', border: 'none', font: 'inherit', color: 'inherit', textAlign: 'left', width: '100%', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
            >
              <span className={`req-status-badge req-status-${s.replaceAll(' ', '-')}`}>{s}</span>
              {LABELS[s]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

RequirementStatusBadge.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  requirementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  statut: PropTypes.string.isRequired,
  onUpdate: PropTypes.func,
  isAdmin: PropTypes.bool,
};
